import React from "react"

import { BuildingTypeInput } from "shared/ui/building-type-input/BuildingTypeInput"

interface InstallationReferenceBuildingTypeFilterInputProps {
  loading?: boolean
}

export const InstallationReferenceBuildingTypeFilterInput = React.memo(
  ({ loading }: InstallationReferenceBuildingTypeFilterInputProps) => {
    return <BuildingTypeInput name="buildingTypes" loading={loading} elevated />
  }
)
